import { RootState } from '../redux/types';

export function selectIsUpdateAvailable(state: RootState): boolean {
  return Boolean(state.sw.updateAvailable);
}
